import { useRef, useState } from "react";

import icoArrow from '../Down_Arrow_3_.png'


function MenuTable(props)
{

    const [visible, setVisible] = useState(0);
    const [type, setType] = useState(props.type);

    
    const changeView = () => {
         if(visible == 0) setVisible(1);
         if(visible == 1) setVisible(0);
    }
     
    if(type=='table' || type==undefined)
    {
        return <td className="gocenter td_btn_option">
                        <div className="option_label link_color"  onClick={changeView} >opcje<img src={icoArrow}/></div>
                        {
                            visible == 1  &&
                            <div className="quickMenu"  onClick={changeView} >                                                                       
                                {props.children}
                            </div>  
                        }                
            </td>
    }   
    else
    {
        return  <div className="gocenter td_btn_option">
                <div className="option_label link_color"  onClick={changeView} >opcje <img src={icoArrow}/></div>
                {
                    visible == 1  &&
                    <div className="quickMenu"  onClick={changeView} >                                                                       
                        {props.children}
                    </div>  
                }                
            </div>
    } 
    
}


export default MenuTable;